export function convertSecToMin(second) {
  if (second <= 60) {
    const secNum = second.toFixed(2);
    return `${secNum} sec`;
  } else {
    const min = Math.floor(second / 60);
    const sec = second % 60;
    const secNum = sec.toFixed(2);
    return `${min} min ${sec < 10 ? `0${secNum} sec` : `${secNum} sec`}`;
  }
}
